import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import DynamicItemHeadingComponent from "@components/common/ui-elements/headings/dynamic-item-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableCustomDateTimePickerBlock
    from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import {CONVICTION_CODES} from "@constants/dropdown-choices";

export default function AdditionalDriverConvictionForm(
    {
        conviction,
        driverIndex,
        convictionIndex,
        motorConvictionsListPropName,
        handleAdditionalDriverConvictionPropChange ,
        addAdditionalDriverConviction ,
        removeAdditionalDriverConviction,
    }
) {

    const generateName = (prop) => {
        return `${motorConvictionsListPropName}[${convictionIndex}][${prop}]`;
    }

    const generateDataBlock = (prop) => {
        return `${motorConvictionsListPropName}.${convictionIndex}.${prop}`;
    }

    const generateIdPrefix = (prop) => {
        return `${motorConvictionsListPropName}-${convictionIndex}-${prop}-`;
    }

    return (
        <div className="additional-driver-conviction-block hidden-box row">

            <DynamicItemHeadingComponent
                text="Conviction"
                itemIndex={convictionIndex + 1}
                onRemoveIconClick={(e) => removeAdditionalDriverConviction(driverIndex,convictionIndex)}
            />


            {/* Date of driving conviction or offence (if conviction still pending)* */}

            <ScrollableCustomDateTimePickerBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Date of driving conviction or offence (if conviction still pending)*"
                required={true}
                controlName={generateName('date')}
                dataBlock={generateDataBlock('date')}
                value={conviction.date}
                onChange={(e) => handleAdditionalDriverConvictionPropChange(driverIndex,convictionIndex, 'date', e.target.value)}
            />

            {/* Conviction code */}

            <ScrollableDropdownBlock
                controlName={generateName('code')}
                dataBlock={generateDataBlock('code')}
                containerCssClass="col-12 py-3 "
                labelText="Conviction code"
                required={true}
                options={CONVICTION_CODES}
                selectedValues={conviction.code}
                onChange={(e) => handleAdditionalDriverConvictionPropChange(driverIndex,convictionIndex, 'code', e.target.value)}
                helpText=""
            />
           
           {'Other' === conviction.code && (
              
              <>
                 <ScrollableTextBoxBlock
                    type="text"
                    containerCssClass="col-12 py-3 extra"
                    labelText="Other conviction code"
                    required={true}
                    controlName={generateName('otherCode')}
                    dataBlock={generateDataBlock('otherCode')}
                    value={conviction.otherCode}
                    onChange={(e) => handleAdditionalDriverConvictionPropChange(driverIndex,convictionIndex, 'otherCode', e.target.value)}
                    inputAttrs={{
                        maxLength: 50
                    }}
                 />
              </>
              
           )}

            {/* Points incurred */}

            <ScrollableTextBoxBlock
                type="number"
                containerCssClass="col-12 py-3 extra"
                labelText="Points incurred"
                required={true}
                controlName={generateName('points')}
                dataBlock={generateDataBlock('points')}
                value={conviction.points}
                onChange={(e) => handleAdditionalDriverConvictionPropChange(driverIndex,convictionIndex, 'points', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />



            {/* Fine incurred (if no fine, enter 0) */}

            <ScrollableTextBoxBlock
                type="number"
                containerCssClass="col-12 py-3 extra"
                labelText="Fine incurred (if no fine, enter 0)"
                required={true}
                controlName={generateName('fines')}
                dataBlock={generateDataBlock('fines')}
                value={conviction.fines}
                onChange={(e) => handleAdditionalDriverConvictionPropChange(driverIndex,convictionIndex, 'fines', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />



            {/*  Ban length in months (if no ban, enter 0) */}

            <ScrollableTextBoxBlock
                type="number"
                containerCssClass="col-12 py-3 extra"
                labelText="Ban length in months (if no ban, enter 0)"
                required={true}
                controlName={generateName('banLengthInMonths')}
                dataBlock={generateDataBlock('banLengthInMonths')}
                value={conviction.banLengthInMonths}
                onChange={(e) => handleAdditionalDriverConvictionPropChange(driverIndex,convictionIndex, 'banLengthInMonths', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />

            {/* Was the driver breathalysed? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Was the driver breathalysed?"
                required={true}
                controlName={generateName('wasDriverBreathalysed')}
                dataBlock={generateDataBlock('wasDriverBreathalysed')}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={conviction.wasDriverBreathalysed}
                onChange={(e) => handleAdditionalDriverConvictionPropChange(driverIndex,convictionIndex, 'wasDriverBreathalysed', e.target.value)}
            />

            {/* Was the offence accident-related? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Was the offence accident-related?"
                required={true}
                controlName={generateName('wasOffenceAccidentRelated')}
                dataBlock={generateDataBlock('wasOffenceAccidentRelated')}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={conviction.wasOffenceAccidentRelated}
                onChange={(e) => handleAdditionalDriverConvictionPropChange(driverIndex,convictionIndex, 'wasOffenceAccidentRelated', e.target.value)}
            />

        </div>
    );

}